import gql from 'graphql-tag';

export const GET_PROGRAM_ADVANCE = gql`
  query GetProgramsAdvance($where: FindManyStoreProgramInput!) {
    getProgramsAdvance(where: $where) {
      id
      name
      floatImage
    }
  }
`;

export const GET_STORE_PROGRAM_PARTICIPANT = gql`
  query GetStoreProgramParticipants(
    $programId: String!
    $managerStoreCode: String
    $storeName: String
    $pagination: PaginationInput!
  ) {
    getStoreProgramParticipants(
      programId: $programId
      managerStoreCode: $managerStoreCode
      storeName: $storeName
      pagination: $pagination
    ) {
      row {
        id
        storeName
        managerStoreCode
      }
      total
    }
  }
`;

export const DOWNLOAD_PROGRAM_PARTICIPANT = gql`
  query DownloadProgramParticipants(
    $programId: String!
    $managerStoreCode: String
    $storeName: String
  ) {
    downloadProgramParticipants(
      programId: $programId
      managerStoreCode: $managerStoreCode
      storeName: $storeName
    ) {
      link
    }
  }
`;
